import { render, staticRenderFns } from "./historialCargos.vue?vue&type=template&id=5e874b96&scoped=true"
import script from "./historialCargos.vue?vue&type=script&lang=js"
export * from "./historialCargos.vue?vue&type=script&lang=js"
import style0 from "./historialCargos.vue?vue&type=style&index=0&id=5e874b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e874b96",
  null
  
)

export default component.exports